export default __webpack_public_path__ + "static/media/verify account icon.16595a39.png";